export const validateDate = (date) => {
  if (!date) return new Date();
  const parsedDate = new Date(date);
  return isNaN(parsedDate.getTime()) ? new Date() : parsedDate;
};
